import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface currentUserDetails {
  id: Nullable<number>,
  firstName: Nullable<string>,
  lastName: Nullable<string>,
  adId: Nullable<string>,
  slug: Nullable<string>,
  email: Nullable<string>,
  groups: Nullable<string[]>,
}

export interface currentUserProps extends currentUserDetails {
  isLocked: boolean,
}

const initialState: currentUserProps = {
  id: null,
  adId: null,
  slug: null,
  email: null,
  firstName: null,
  lastName: null,
  isLocked: false,
  groups: null
};

export const currentUserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserDetails: (
        state,
        action: PayloadAction<currentUserDetails>
    ) => {
      state.id = action.payload.id;
      state.adId = action.payload.adId;
      state.slug = action.payload.slug;
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.groups = action.payload.groups;
    },
    setLockedUser: (state, action: PayloadAction<boolean>) => {
      state.isLocked = action.payload;
    }
  }
});

export const {
  setUserDetails,
  setLockedUser
} = currentUserSlice.actions;

export const userGroupsSelector = (state) => state.user.groups || [];

export default currentUserSlice.reducer;
